import { render, staticRenderFns } from "./ManageUser.vue?vue&type=template&id=b52f1b44&scoped=true&"
import script from "./ManageUser.vue?vue&type=script&lang=js&"
export * from "./ManageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f1b44",
  null
  
)

export default component.exports